import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import './FAQAccordion.css'

const FAQAccordion = ({ title = "Frequently Asked Questions", subtitle = "Quick answers to common questions about EveryKits" }) => {
  const [activeFaq, setActiveFaq] = useState(0); // Default to first FAQ item

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqData = [
    {
      question: "Are your tools really free?",
      answer: "Yes! All our tools are completely free to use with no hidden charges, subscriptions, or premium features."
    },
    {
      question: "Do you store my data?",
      answer: "No. Most of our tools process data entirely in your browser. We don't store your files, text, or results after your session ends."
    },
    {
      question: "Can I use your tools commercially?",
      answer: "Yes! Our tools can be used for both personal and commercial purposes without any restrictions."
    },
    {
      question: "How do I report a bug?",
      answer: "Use the contact form above or email us directly. We appreciate all feedback and bug reports!"
    },
    {
      question: "Do you offer API access?",
      answer: "Currently, our tools are available only through the web interface. We're considering API options for the future."
    }
  ];

  return (
    <div className="faq-accordion-wrapper">
      <div className="faq-header">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="faq-accordion">
        {faqData.map((faq, index) => (
          <div key={index} className={`faq-accordion-item ${activeFaq === index ? 'active' : ''}`}>
            <button
              className="faq-accordion-header"
              onClick={() => toggleFaq(index)}
              aria-expanded={activeFaq === index}
              aria-controls={`faq-content-${index}`}
            >
              <h3>{faq.question}</h3>
              <div className="faq-accordion-icon">
                {activeFaq === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </button>
            <div
              id={`faq-content-${index}`}
              className={`faq-accordion-content ${activeFaq === index ? 'open' : ''}`}
              aria-hidden={activeFaq !== index}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FAQAccordion
